// extracted by mini-css-extract-plugin
module.exports = {"commentEdit":"commentEdit_commentEdit__3vIX3","commentArea":"commentEdit_commentArea__3M-WT","buttonContainer":"commentEdit_buttonContainer__1sUMZ"};